import * as qs from 'query-string';
import locales from './locales';
import {DateRange} from "./common/dtos";

const idPathParam = ':id';

export const loginPath = '/login';
export const itemsPath = '/items';
export const createItemPath = '/create-item';
const viewItemPathBase = '/view-item';
export const viewItemPathTemplate = `${viewItemPathBase}/${idPathParam}`;
export const clientsPath = '/clients';
export const createClientPath = '/create-client';
const viewClientPathBase = '/view-client';
export const viewClientPathTemplate = `${viewClientPathBase}/${idPathParam}`;
export const rentalsPath = '/';

export const rentalHistoryPathBase = `/rentals`;
export const itemRentalHistoryPathTemplate = `${rentalHistoryPathBase}/items/${idPathParam}`;
export const clientRentalHistoryPathTemplate = `${rentalHistoryPathBase}/clients/${idPathParam}`;

export const createRentalPath = '/create-rental';
const viewRentalPathBase = '/view-rental';
export const viewRentalPathTemplate = `${viewRentalPathBase}/${idPathParam}`;
export const createReturnalPath = '/create-returnal';
const viewReturnalPathBase = '/view-returnal';
export const viewReturnalPathTemplate = `${viewReturnalPathBase}/${idPathParam}`;
export const summariesPath = '/summaries';
export const revenueSummaryPath = '/revenue-summary';
const clientRevenueSummaryPathBase = '/client-revenue-summaries';
export const clientRevenueSummaryPathTemplate = `${clientRevenueSummaryPathBase}/${idPathParam}`;

export const incomingInvoicesPath = '/incoming-invoices';
export const createIncomingInvoicePath = '/create-incoming-invoice';
const viewIncomingInvoicePathBase = '/view-incoming-invoice';
export const viewIncomingInvoicePathTemplate = `${viewIncomingInvoicePathBase}/${idPathParam}`;

const clientSummaryPathBase = '/client-summaries';
export const clientSummaryPathTemplate = `${clientSummaryPathBase}/${idPathParam}`;
const clientCalendarPathBase = '/client-calendar';
export const clientCalendarPathTemplate = `${clientCalendarPathBase}/${idPathParam}`;
export const statsPath = '/stats';
export const categoryStatsPath = '/stats/category';
export const incomingInvoiceStatsPath = '/stats/incoming-invoice';
export const overallStatsPath = '/stats/overall';
export const alertsPath = '/alerts';
export const maintenancesPath = '/maintenances';
export const createMaintenanceHistoryItemPathBase = '/create-maintenance-history';
const viewMaintenanceHistoryItemPathBase = '/view-maintenance-history';
export const viewMaintenanceHistoryItemPathTemplate = `${viewMaintenanceHistoryItemPathBase}/${idPathParam}`;
export const checklistAlertsPath = '/checklist-alerts';
export const eventAlertsPath = '/event-alerts';

export const eventsPath = '/events';
export const createEventPath = '/create-event';
const viewEventPathBase = '/view-event';
export const viewEventPathTemplate = `${viewEventPathBase}/${idPathParam}`;

const createChecklistPathBase = '/create-checklist';
export const createChecklistPathTemplate = `${createChecklistPathBase}`;
const viewChecklistPathBase = '/view-checklist';
export const viewChecklistPathTemplate = `${viewChecklistPathBase}/${idPathParam}`;
export const sendRentalChecklistPathTemplate = `${viewRentalPathBase}/${idPathParam}/checklist`;
export const sendReturnalChecklistPathTemplate = `${viewReturnalPathBase}/${idPathParam}/checklist`;

export const sendRentalDocumentsPathTemplate = `${viewRentalPathBase}/${idPathParam}/documents`;
export const sendReturnalDocumentsPathTemplate = `${viewReturnalPathBase}/${idPathParam}/documents`;

export const userManagementPath = '/user-management';

export const inventoryPath = '/inventory';
export const warehousesPath = `/inventory/warehouses`;
export const inventoryStocksPath = `/inventory/stocks`;
const viewInventoryStockPathBase = `/inventory/view-stock`;
export const viewInventoryStockPathTemplate = `${viewInventoryStockPathBase}/${idPathParam}`;
const createInventoryStockItemPathBase = `/inventory/create-stock-item`;
export const createInventoryStockItemPathTemplate = `${createInventoryStockItemPathBase}/${idPathParam}`;
export const inventoryTransportLettersPath = `/inventory/transport-letters`;
export const createInventoryTransportLetterPath = `${inventoryTransportLettersPath}/create`;
const viewInventoryTransportLetterPathBase = `${inventoryTransportLettersPath}/view`;
export const viewInventoryTransportLetterPathTemplate = `${viewInventoryTransportLetterPathBase}/${idPathParam}`;

export const inventorySalesPath = '/inventory-sales';
export const createInventorySalePath = '/create-inventory-sale';
const viewInventorySalePathBase = '/view-inventory-sale';
export const viewInventorySalePathTemplate = `${viewInventorySalePathBase}/${idPathParam}`;

export const createInvoicePath = '/create-invoice';
export const invoicesPath = '/invoices';
export const clientInvoicesPathBase = '/client-invoices';
export const clientInvoicesPathTemplate = `${clientInvoicesPathBase}/${idPathParam}`;
const viewInvoicePathBase = '/view-invoice';
export const viewInvoicePathTemplate = `${viewInvoicePathBase}/${idPathParam}`;


export interface CreateChecklistArgs {
  rentalItemId: number,
  rentalId?: number,
  returnalId?: number,
}

export function viewRentalChecklist(id: number | undefined | null): string {
  const replacement = id ? String(id) : '';
  return `${sendRentalChecklistPathTemplate.replace(idPathParam, replacement)}`;
}

export function viewReturnalChecklist(id: number | undefined | null): string {
  const replacement = id ? String(id) : '';
  return `${sendReturnalChecklistPathTemplate.replace(idPathParam, replacement)}`;
}

export function viewRentalDocuments(id: number | undefined | null): string {
  const replacement = id ? String(id) : '';
  return `${sendRentalDocumentsPathTemplate.replace(idPathParam, replacement)}`;
}

export function viewReturnalDocuments(id: number | undefined | null): string {
  const replacement = id ? String(id) : '';
  return `${sendReturnalDocumentsPathTemplate.replace(idPathParam, replacement)}`;
}

export function createChecklistPath(args: CreateChecklistArgs): string {
  const query = qs.stringify(args, {skipNull: true});
  return `${createChecklistPathTemplate}?${query}`;
}

export function viewChecklistPath(id: number | undefined | null): string {
  const replacement = id ? String(id) : '';
  return viewChecklistPathTemplate.replace(idPathParam, replacement);
}

export function viewClientRentalHistoryPath(clientId: number) {
  const replacement = clientId ? String(clientId) : '';
  return clientRentalHistoryPathTemplate.replace(idPathParam, replacement);
}

export function viewItemRentalHistoryPath(itemId: number) {
  const replacement = itemId ? String(itemId) : '';
  return itemRentalHistoryPathTemplate.replace(idPathParam, replacement);
}

export function viewClientPath(id: number | undefined | null): string {
  const replacement = id ? String(id) : '';
  return viewClientPathTemplate.replace(idPathParam, replacement);
}

export function viewEventPath(id: number | undefined | null): string {
  const replacement = id ? String(id) : '';
  return viewEventPathTemplate.replace(idPathParam, replacement);
}

export function createEventPathWithArgs(user?: string, dateRange?: DateRange): string {
  const query = qs.stringify({
    salesUser: user,
    start: dateRange?.start.toISOString(),
    end: dateRange?.end.toISOString()
  }, {
    skipNull: true
  });
  return `${createEventPath}?${query}`;
}

export function viewItemPath(id?: number): string {
  const replacement = id ? String(id) : '';
  return viewItemPathTemplate.replace(idPathParam, replacement);
}

export function viewRentalPath(id?: number): string {
  const replacement = id ? String(id) : '';
  return viewRentalPathTemplate.replace(idPathParam, replacement);
}

export function viewReturnalPath(id: number | null): string {
  const replacement = id ? String(id) : '';
  return viewReturnalPathTemplate.replace(idPathParam, replacement);
}

export function viewClientSummaryPath(clientId: number) {
  return clientSummaryPathTemplate.replace(idPathParam, String(clientId));
}

export function clientSummaryPath(id: number, year: number, month: number): string {
  const path = clientSummaryPathTemplate.replace(idPathParam, String(id));
  const query = qs.stringify({year, month});
  return `${path}?${query}`;
}

export function viewClientCalendarPath(clientId: number) {
  return clientCalendarPathTemplate.replace(idPathParam, String(clientId));
}

export function viewIncomingInvoicePath(id: number | undefined): string {
  const replacement = id ? String(id) : '';
  return viewIncomingInvoicePathTemplate.replace(idPathParam, replacement);
}

export function viewInventoryStockPath(id: number | undefined): string {
  const replacement = id ? String(id) : '';
  return viewInventoryStockPathTemplate.replace(idPathParam, replacement);
}

export function viewMaintenanceHistoryItemPath(id: number | undefined): string {
  const replacement = id ? String(id) : '';
  return viewMaintenanceHistoryItemPathTemplate.replace(idPathParam, replacement);
}

export function viewInventoryTransportLetterPath(id: number | undefined): string {
  const replacement = id ? String(id) : '';
  return viewInventoryTransportLetterPathTemplate.replace(idPathParam, replacement);
}

export function createInventoryStockItemPath(inventoryStockId: number): string {
  return createInventoryStockItemPathTemplate.replace(idPathParam, String(inventoryStockId));
}

export function viewSalePath(id: number): string {
  return viewInventorySalePathTemplate.replace(idPathParam, String(id));
}

export function clientInvoicesPath(id: number): string {
  return clientInvoicesPathTemplate.replace(idPathParam, String(id));
}

export function viewInvoicePath(id: number): string {
  return viewInvoicePathTemplate.replace(idPathParam, String(id));
}

export function clientRevenueSummaryPath(id: number, year: number, month: number): string {
  return `${clientRevenueSummaryPathBase}/${id}?year=${year}&month=${month}`;
}

export interface IdPageUrlParams {
  id?: string;
}

const pathBaseToTitleMap: { [key: string]: string } = {
  [loginPath]: locales.login,
  [itemsPath]: locales.items,
  [createItemPath]: locales.item_add,
  [viewItemPathBase]: locales.item_details,
  [clientsPath]: locales.clients,
  [createClientPath]: locales.client_create,
  [viewClientPathBase]: locales.client_details,
  [eventsPath]: locales.event_calendar,
  [createEventPath]: locales.event_create,
  [viewEventPathBase]: locales.event_details,
  [rentalsPath]: locales.rentals,
  [rentalHistoryPathBase]: locales.rentals,
  [createRentalPath]: locales.rental_create,
  [viewRentalPathBase]: locales.rental_details,
  [sendRentalChecklistPathTemplate]: locales.checklists,
  [sendReturnalChecklistPathTemplate]: locales.checklists,
  [sendRentalDocumentsPathTemplate]: locales.documents,
  [sendReturnalDocumentsPathTemplate]: locales.documents,
  [createReturnalPath]: locales.return_create,
  [viewReturnalPathBase]: locales.return_details,
  [summariesPath]: locales.summaries,
  [revenueSummaryPath]: locales.revenue_summary,
  [clientRevenueSummaryPathBase]: locales.revenue_summary,
  [clientSummaryPathBase]: locales.summary,
  [clientCalendarPathBase]: locales.calendar_events,
  [statsPath]: locales.statistics,
  [categoryStatsPath]: locales.item_categories,
  [incomingInvoiceStatsPath]: locales.incoming_invoices,
  [overallStatsPath]: locales.overall,
  [alertsPath]: locales.alerts,
  [checklistAlertsPath]: locales.checklist_alerts,
  [eventAlertsPath]: locales.event_alerts,
  [incomingInvoicesPath]: locales.incoming_invoices,
  [createIncomingInvoicePath]: locales.incoming_invoice_add,
  [viewIncomingInvoicePathBase]: locales.incoming_invoice_details,
  [maintenancesPath]: locales.maintenance_worksheets,
  [createMaintenanceHistoryItemPathBase]: locales.maintenance_worksheet,
  [viewMaintenanceHistoryItemPathBase]: locales.maintenance_worksheet,
  [createChecklistPathBase]: locales.checklist,
  [viewChecklistPathBase]: locales.checklist,
  [userManagementPath]: locales.user_management,
  [warehousesPath]: locales.warehouses,
  [inventoryStocksPath]: locales.inventory_stocks,
  [viewInventoryStockPathBase]: locales.inventory_stock_details,
  [createInventoryStockItemPathBase]: locales.inventory_stock_item_add,
  [inventoryTransportLettersPath]: locales.transport_letters,
  [createInventoryTransportLetterPath]: locales.transport_letter_add,
  [viewInventoryTransportLetterPathBase]: locales.transport_letter_details,
  [inventorySalesPath]: locales.sales,
  [createInventorySalePath]: locales.sales_create,
  [viewInventorySalePathBase]: locales.sales_details,
  [createInvoicePath]: locales.invoice_create,
  [invoicesPath]: locales.invoices,
  [clientInvoicesPathBase]: locales.client_invoices,
  [viewInvoicePathBase]: locales.invoice,
};

export function getTitleForPath(pathname: string, loggedIn: boolean): string | undefined {
  if (loggedIn) {
    let candidate = pathname.endsWith('/') && pathname.length > 1
      ? pathname.slice(0, -1)
      : pathname;

    while (candidate.length > 0) {
      const title = pathBaseToTitleMap[candidate];
      if (title !== undefined) {
        return title;
      }

      const lastSlashIdx = candidate.lastIndexOf('/');
      if (lastSlashIdx <= 0) {
        candidate = '/';
      } else {
        candidate = candidate.slice(0, lastSlashIdx);
      }

      if (candidate === '/') {
        return pathBaseToTitleMap[candidate];
      }
    }

    return undefined;
  } else {
    return locales.login;
  }
}


// WEBPACK FOOTER //
// ./src/paths.ts